/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GondolaMappedWelcomeAction
 */
export interface GondolaMappedWelcomeAction {
    /**
     * 
     * @type {number}
     * @memberof GondolaMappedWelcomeAction
     */
    id: number;
}

/**
 * Check if a given object implements the GondolaMappedWelcomeAction interface.
 */
export function instanceOfGondolaMappedWelcomeAction(value: object): value is GondolaMappedWelcomeAction {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GondolaMappedWelcomeActionFromJSON(json: any): GondolaMappedWelcomeAction {
    return GondolaMappedWelcomeActionFromJSONTyped(json, false);
}

export function GondolaMappedWelcomeActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GondolaMappedWelcomeAction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function GondolaMappedWelcomeActionToJSON(json: any): GondolaMappedWelcomeAction {
    return GondolaMappedWelcomeActionToJSONTyped(json, false);
}

export function GondolaMappedWelcomeActionToJSONTyped(value?: GondolaMappedWelcomeAction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

